<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        :title="title"
        @save="$refs.Form.save()"
        extraLarge
        ref="Modal"
    >
        <Form
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({

    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {

            this.$refs.Modal.show()
        },
        handleExit(usuario) {

            this.$emit('save', usuario)
            this.$refs.Modal.hide()
        },
    },
    props: {
        title: { type: String, default: 'Novo usuário' }
    }
}
</script>